var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-phonelink",
    "data-name": "Icon material-phonelink",
    d: "M4.5,8.25H24.75V6H4.5A2.257,2.257,0,0,0,2.25,8.25V20.625H0V24H15.75V20.625H4.5ZM25.875,10.5h-6.75A1.128,1.128,0,0,0,18,11.625v11.25A1.128,1.128,0,0,0,19.125,24h6.75A1.128,1.128,0,0,0,27,22.875V11.625A1.128,1.128,0,0,0,25.875,10.5ZM24.75,20.625h-4.5V12.75h4.5Z",
    transform: "translate(0 -6)",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerIcon);
export default __webpack_public_path__ + "static/media/computerIcon.fc3ba6f1.svg";
export { ForwardRef as ReactComponent };